// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline-lead{font-size:13px;color:var(--color-grey-1);margin:12px 0;line-height:1.77}", ""]);
// Exports
module.exports = exports;
